import { createContext, useState } from "react"

interface TableStateType<FilterState, StateState> {
  [key: string]: {
    orderBy: string
    dense: boolean
    order: "asc" | "desc"
    page: number
    rowsPerPage: number
    filters: FilterState
    state: StateState
  }
}

interface TableContextType<FilterState, StateState> {
  tableState: TableStateType<FilterState, StateState>
  updateTableState: (newState: TableStateType<FilterState, StateState>) => void
  deleteTableState: (tableId: string) => void
}

// eslint-disable-next-line react-refresh/only-export-components
export const TableContext = createContext<TableContextType<unknown, unknown>>(
  {} as TableContextType<unknown, unknown>
)

export function TableProvider({ children }: { children: React.ReactNode }) {
  const [tableState, setTableState] = useState({})

  const updateTableState = (newState: TableStateType<unknown, unknown>) => {
    setTableState((prevState) => ({
      ...prevState,
      ...newState,
    }))
  }

  const deleteTableState = (tableId: string) => {
    setTableState((prevState) => {
      const { [tableId]: _, ...rest } = prevState as { [key: string]: unknown }
      return rest
    })
  }

  return (
    <TableContext.Provider value={{ tableState, updateTableState, deleteTableState }}>
      {children}
    </TableContext.Provider>
  )
}
